import React from 'react';
import ImageWithCache from './ImageWithCache';
import './MorePage.css';

const MorePage = () => {
  return (
    <div className="more-page">
      <div className="more-content">
        <p className="more-title">Ще</p>

        <div className="more-card">
          <div className="more-grid-3">
            <div className="more-grid-item">
              <div className="more-grid-icon">
                <ImageWithCache className="more-grid-icon-img" src="/other-icons/other-invite.webp" alt="Запросити друга" />
              </div>
              <p className="more-grid-text">Запросити<br />друга</p>
            </div>
            <div className="more-grid-item">
              <div className="more-grid-icon">
                <ImageWithCache className="more-grid-icon-img" src="/other-icons/other-support.webp" alt="Служба підтримки" />
              </div>
              <p className="more-grid-text">Служба<br />підтримки</p>
            </div>
            <div className="more-grid-item">
              <div className="more-grid-icon">
                <ImageWithCache className="more-grid-icon-img" src="/other-icons/other-scan.webp" alt="Сканер QR-коду" />
              </div>
              <p className="more-grid-text">Сканер<br />QR-коду</p>
            </div>
          </div>
        </div>

        <div className="more-card">
          <div className="more-row">
            <ImageWithCache className="more-row-icon" src="/other-icons/other-car.webp" alt="Автострахування" />
            <div className="more-row-text">
              <p className="more-row-title">Автострахування</p>
              <p className="more-row-subtitle">ОСЦПВ, Зелена картка та інше</p>
            </div>
          </div>
          <div className="more-row">
            <ImageWithCache className="more-row-icon" src="/other-icons/other-phone.webp" alt="Мобільний зв'язок" />
            <div className="more-row-text">
              <p className="more-row-title">Мобільний зв'язок</p>
              <p className="more-row-subtitle">eSIM та керування номерами</p>
            </div>
          </div>
          <div className="more-row">
            <ImageWithCache className="more-row-icon" src="/other-icons/other-fuel.webp" alt="Заправка на WOG" />
            <div className="more-row-text">
              <p className="more-row-title">Заправка на WOG</p>
              <p className="more-row-subtitle">Не виходячи з авто</p>
            </div>
          </div>
          <div className="more-row">
            <ImageWithCache className="more-row-icon" src="/other-icons/other-coupon.webp" alt="Програми лояльності" />
            <div className="more-row-text">
              <p className="more-row-title">Програми лояльності</p>
              <p className="more-row-subtitle">Накопичення бонусів</p>
            </div>
          </div>
        </div>

        <div className="more-card">
          <div className="more-row">
            <ImageWithCache className="more-row-icon" src="/other-icons/other-security.webp" alt="Про безпеку в mono" />
            <div className="more-row-text">
              <p className="more-row-title">Про безпеку в mono</p>
              <p className="more-row-subtitle">Запобігання шахрайству</p>
            </div>
          </div>
          <div className="more-row">
            <ImageWithCache className="more-row-icon" src="/other-icons/other-sign.webp" alt="monoКЕП" />
            <div className="more-row-text">
              <p className="more-row-title">monoКЕП</p>
              <p className="more-row-subtitle">Ваш електронний підпис</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MorePage;
